// base64加密字符串
const encryptionStr = (str = "") => {
  try {
    // 将中文字符串先转换为 UTF-8 字节序列
    const utf8Str = encodeURIComponent(str);
    const base64Str = btoa(utf8Str);
    const URIStr = encodeURIComponent(base64Str);
    return URIStr;
  } catch (error) {
    console.log("加密出错：", error);
    return str;
  }
};

// base64解密字符串
const decryptionStr = (str = "") => {
  try {
    const URIStr = decodeURIComponent(str);
    const decodedStr = atob(URIStr);
    // 将 UTF-8 字节序列转换回中文
    const originalStr = decodeURIComponent(decodedStr);
    return originalStr;
  } catch (error) {
    console.log("解密出错：", error);
    return "";
  }
};

// 解析 意见反馈 页面参数
// 格式如下： CRM&10001&测试提交人&商城小程序
const formatFeedbackParam = (str = "") => {
  try {
    if (!str) return {};
    const originalStr = decryptionStr(str);
    const strList = originalStr.split("&");
    return {
      sys: strList[0],
      userCode: strList[1],
      userName: strList[2],
      sysTerminal: strList[3], // 系统终端
      otherKey: strList[4] // 其他字段
    };
  } catch (error) {
    return {};
  }
};

export { encryptionStr, decryptionStr, formatFeedbackParam };
